export const environment = {
  production: true,
  lambdaAuthUrl: 'https://m6h5cmly7zpigzhvhr4l3bzclq0tnrjt.lambda-url.us-east-1.on.aws',
  clientServicesUrl: 'https://z3dwmmzp2kpvinuwgj7ttcgmmi0qzrhr.lambda-url.us-east-1.on.aws',
  googleMapsApiKey: 'AIzaSyAHpKduH9Ia6S8GBg63EGsp0W2EWKXF_z8'
};
